<template>
  <v-app class="home-layout">
    <div class="max-height" style="display: flex;">
      <v-navigation-drawer
        absolute
        temporary>
        <app-menu />
      </v-navigation-drawer>
      <v-toolbar app color="#0C2E4A">
        <v-toolbar-title><v-img style="cursor: pointer" @click="logoClick()" width="140" :src="logoPath()" /></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
          <slot name="toolbar-item"></slot>
          <v-btn v-if="!signedIn" class="toolbar-btn" flat @click="$router.push('/sign_in')">Login</v-btn>
          <v-btn v-if="signedIn" class="toolbar-btn" flat @click="signOut()">Logout</v-btn>
        </v-toolbar-items>
        <v-toolbar-side-icon @click="$root.$emit('display-nav-menu')" class="hidden-md-and-up"></v-toolbar-side-icon>
      </v-toolbar>
      <v-content>
        <v-container fluid pa-0 max-width-1200 style="height: 100%;">
          <v-layout justify-center fill-height>
            <v-flex xs11 pt-5>
              <v-layout fill-height row wrap>
                <v-flex xs12>
                  <slot></slot>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </div>
  </v-app>
</template>
<script>
import AppMenu from "../Menu"
export default {
  name: 'HomeLayout',
  components: { 'app-menu': AppMenu },
  data() {
    return {
      items: [
        { title: 'Home', icon: 'dashboard' },
        { title: 'About', icon: 'question_answer' }
      ],
      signedIn: false,
      admin: false
    }
  },
  methods: {
    signOut() {
      // remove all cookie
      this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie))
      this.signedIn = false
      this.$router.push('/')
    },
    logoClick() {
      if (this.signedIn) {
        this.$router.push('/dashboard')
      } else {
        this.$router.push('/')
      }
    },
    logoPath() {
      if (this.$root.getEnvironment() === 'prod') return 'static/facilitapay-logo-color.png'
        return 'static/facilitapay-dev-dark.png'
    }
  },
  mounted() {
    this.signedIn = this.$cookies.isKey('api_token') && this.$cookies.get('api_token') !== ''
    this.admin = this.$cookies.isKey('admin') && this.$cookies.get('admin') === 'true'
  }
}
</script>
<style>
  .theme--light.application.home-layout {
    background-color: #092f4f !important;
    background: linear-gradient(90deg, rgba(9,47,79,1) 0%, rgba(9,47,79,1) 42%, rgba(70, 139, 147, 1) 100%)!important;
  }

  .v-text-field--box .v-input__slot {
    border-bottom-left-radius: 2px;
    border-top-right-radius: 0px;
  }

  .app-navigation { height: 60px; background-color: var(--navigation-color); }
  .app-footer-disabled { position: absolute; left: 0px; bottom: -20px;}

  body { padding: 0px; margin: 0px; }

  body,
  div.max-height { height: 100%!important; position: relative!important; }

  .max-width-1200 { max-width: 1200px!important; }

  .home-layout h1.max {
    font-weight: 700;
    font-size: 42px!important;
    line-height: 1.2;
    color: white;
    text-transform: none;
    letter-spacing:0px;
  }
  .font-blue { color: var(--text-dot-color)!important }

  h4 { font-weight: 300!important; }

  .btn-style, .btn-style--secondary, .btn-style--tertiary, .btn-style--gray {
    height: 56px!important;
  }
  .btn-style {
    background-color: var(--primary-button-background-color)!important;
  }
  .btn-style--secondary {
    background-color: var(--secondary-button-background-color)!important;
  }
  .btn-style--tertiary {
    background-color: var(--tertiary-button-background-color)!important;
  }
  .btn-style--gray {
    background-color: var(--silver-color)!important;
    color: var(--silver-color-font-color)!important;
  }

  .card-title-text {
    flex: 1;
    display: flex;
    justify-content: center;
    color: var(--background-color);
  }

  .input-control-with-grow > .v-input__control {
    flex-grow: 1;
  }

  /* v-autocomplete changes to match the appearence of other fields */
  .v-autocomplete.v-input>.v-input__control>.v-input__slot {
    padding: 0 12px!important;
  }

  .v-input.v-text-field.v-autocomplete {
    margin: 0px;
    padding: 0px;
  }
  .v-input.v-text-field.v-autocomplete input {
    margin-top: 22px!important;
  }
  .v-text-field.v-autocomplete>.v-input__control>.v-input__slot {
    align-items: stretch!important;
    min-height: 56px!important;
  }
  .v-text-field.v-autocomplete .v-text-field__details {
    margin-bottom: 8px!important;
    padding-left: 10px!important;
  }
  .v-text-field.v-autocomplete .v-label {
    top: 18px!important;
  }
  .v-text-field.v-autocomplete .v-label--active {
    transform: translateY(-6px) scale(.75);
  }
  .v-text-field.v-autocomplete .v-input__append-inner {
    align-self: center;
  }
  .v-text-field.v-autocomplete>.v-input__control>.v-input__slot:before {
    border-width: thin 0!important;
  }
  .home-layout .toolbar-btn {
    color: #E9FBF8 !important;
  }

  /*Animations*/

  .fade-enter-active {
    transition: all .9s ease;
  }
  .fade-leave-active {
    transition: all .0s ease;
  }
  .fade-enter {
    opacity: 0;
  }
  .fade-leave-to {
    opacity: 0;
  }
  .arrow-icon-small {
    height: 14px!important;
    margin: 0px!important;
    padding: 0px!important;
    width: 12px!important;
    font-size: 14px!important;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/HomeLayout.vue